import {Component, computed, input, output} from '@angular/core';
import {NotificationSummary} from "../../../../../api";
import {TranslateDirective} from '@ngx-translate/core';
import {ElciaButton} from '../../../buttons/button/button';

@Component({
  selector: 'elcia-notification-item',
  imports: [
    ElciaButton,
    TranslateDirective
  ],
  templateUrl: './notification-item.html',
  styleUrl: './notification-item.scss',
})
export class NotificationItem {
  notification = input.required<NotificationSummary>();
  type = computed(() => this.notification().type)

  onDelete = output<NotificationSummary>();
  goToNotification = output<NotificationSummary>();

  deleteNotification() {
    this.onDelete.emit(this.notification());
  }
}
